import React, { useEffect } from 'react';
import './style.css';
import avatar from 'Assets/avatarnew.svg';
import facebook from 'Assets/facebook.svg';
import twitter from 'Assets/twitter.svg';
import website from 'Assets/website.svg';
import { NavLink} from "react-router-dom";
function Organizers(props) {
  useEffect(() => {

  }, [])

  return (
    <React.Fragment>
      <div className="organizer-block"
      style={{minHeight:props.show_Icon !== false && 
        // eslint-disable-next-line 
      (props.website_url ||props.facebook_handle || props.twitter_handle !== undefined && !null) &&
      (props.Organizer_text !== undefined && !null) ? 165 : 130 }}>
        {
          props.Organizer_link ? 
          <NavLink to={props.Organizer_link}>
            <div className="organizer-img">
              <img src={props.profile_pic !== undefined || null ? props.profile_pic : avatar} alt="img" className="img-fluid" />
            </div>
          </NavLink>
          :
          <React.Fragment>
            <div className="organizer-img">
              <img src={props.profile_pic !== undefined || null ? props.profile_pic : avatar} alt="img" className="img-fluid" />
            </div>
          </React.Fragment>
        }

        <div className="organizer-det">
        {
          props.Organizer_link ? 
          <NavLink to={props.Organizer_link}>
            <h3>{props.Organizer_firstname !== undefined || props.Organizer_firstname !== null ? props.Organizer_firstname : ''} {props.Organizer_lastname !== undefined || null ? props.Organizer_lastname:null}
              {props.admin_flag &&
                <span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> ADMIN</span>        
              }
            </h3>
            { props.Organizer_text !== undefined && props.Organizer_text !== null &&
              <p>{props.Organizer_text}</p>
            }
          </NavLink>
          :
          <React.Fragment>
            <h3>{props.Organizer_firstname !== undefined || props.Organizer_firstname !== null ? props.Organizer_firstname : ''} {props.Organizer_lastname !== undefined || null ? props.Organizer_lastname:null}</h3>
            { props.Organizer_text !== undefined && props.Organizer_text !== null &&
            <p>{props.Organizer_text}</p>
            }
          </React.Fragment>
        }
          <div className="organizer-social" style={{ display: props.show_Icon === false ? "none" : null }}>
            {
              props.website_url
                ?
                <a rel="noopener noreferrer" href={props.website_url}><img src={website} alt="img" /></a>
                :
                null
            }
            {
              props.facebook_handle
                ?
                <a rel="noopener noreferrer" href={`https://www.facebook.com/${props.facebook_handle}`}><img src={facebook} alt="img" /></a>
                :
                null
            }
            {
              props.twitter_handle
                ?
                <a rel="noopener noreferrer" href={`https://www.twitter.com/${props.twitter_handle}`}><img src={twitter} alt="img" /></a>
                :
                null
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  )

}

export default Organizers;